import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result } from '@digibricks/core';
import { ErrorResultHandler } from '@lib/domain-common';
import { AxiosApi } from '@digibricks/plugin-axios';
import { User, UserSummary } from '../../../core';
export var USER_API = 'USER_API';
export var UserApi = /*#__PURE__*/function (_AxiosApi) {
  _inherits(UserApi, _AxiosApi);

  var _super = _createSuper(UserApi);

  function UserApi(axiosInstance) {
    var _this;

    _classCallCheck(this, UserApi);

    _this = _super.call(this, 'user', axiosInstance);
    _this.axiosInstance = axiosInstance;
    return _this;
  }

  _createClass(UserApi, [{
    key: "getUsers",
    value: function () {
      var _getUsers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(useCaseInput) {
        var queryParams, jsonResponse, parsedBodyResponse, userSummaries;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                queryParams = {
                  userIds: useCaseInput.userIds.join(',')
                };
                _context.prev = 1;
                _context.next = 4;
                return this.axios.get(this.url, {
                  headers: {
                    Authorization: "Bearer ".concat(localStorage.getItem('access_token'))
                  },
                  params: queryParams
                });

              case 4:
                jsonResponse = _context.sent;
                parsedBodyResponse = jsonResponse.data;
                userSummaries = parsedBodyResponse.data.map(function (user) {
                  return UserSummary.fromJson(user);
                });
                return _context.abrupt("return", Result.combineArray(userSummaries));

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](1);
                return _context.abrupt("return", ErrorResultHandler(_context.t0));

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 10]]);
      }));

      function getUsers(_x) {
        return _getUsers.apply(this, arguments);
      }

      return getUsers;
    }() // eslint-disable-next-line @typescript-eslint/no-unused-vars

  }, {
    key: "getUserById",
    value: function () {
      var _getUserById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id) {
        var url, jsonResponse, parsedBodyResponse;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                url = "".concat(this.url, "/").concat(id);
                _context2.next = 4;
                return this.axios.get(url);

              case 4:
                jsonResponse = _context2.sent;
                parsedBodyResponse = jsonResponse.data;
                return _context2.abrupt("return", User.create(parsedBodyResponse.data));

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", ErrorResultHandler(_context2.t0));

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 9]]);
      }));

      function getUserById(_x2) {
        return _getUserById.apply(this, arguments);
      }

      return getUserById;
    }()
  }, {
    key: "searchUser",
    value: function () {
      var _searchUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref) {
        var search, userIds, queryParams, jsonResponse, parsedBodyResponse;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                search = _ref.search, userIds = _ref.userIds;
                _context3.prev = 1;
                queryParams = _objectSpread(_objectSpread({}, search && {
                  search: search
                }), userIds && {
                  userIds: userIds.join(',')
                });
                _context3.next = 5;
                return this.axios.get(this.url, {
                  params: queryParams
                });

              case 5:
                jsonResponse = _context3.sent;
                parsedBodyResponse = jsonResponse.data;
                return _context3.abrupt("return", Result.ok(parsedBodyResponse.data));

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3["catch"](1);
                return _context3.abrupt("return", ErrorResultHandler(_context3.t0));

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1, 10]]);
      }));

      function searchUser(_x3) {
        return _searchUser.apply(this, arguments);
      }

      return searchUser;
    }()
  }, {
    key: "updateProfile",
    value: function () {
      var _updateProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(useCaseInput) {
        var _id, _input, url, jsonResponse, parsedBodyResponse;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _id = useCaseInput.id, _input = useCaseInput.input;
                url = "".concat(this.url, "/").concat(_id);
                _context4.next = 5;
                return this.axios.patch(url, _input);

              case 5:
                jsonResponse = _context4.sent;
                parsedBodyResponse = jsonResponse.data;
                return _context4.abrupt("return", Result.ok(parsedBodyResponse.message));

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](0);
                return _context4.abrupt("return", ErrorResultHandler(_context4.t0));

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 10]]);
      }));

      function updateProfile(_x4) {
        return _updateProfile.apply(this, arguments);
      }

      return updateProfile;
    }()
  }, {
    key: "changePassword",
    value: function () {
      var _changePassword = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(useCaseInput) {
        var _id2, _input2, oldPassword, newPassword, url, request, jsonResponse, parsedBodyResponse;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _id2 = useCaseInput.id, _input2 = useCaseInput.input;
                oldPassword = _input2.oldPassword, newPassword = _input2.newPassword;
                url = "".concat(this.url, "/").concat(_id2, "/change-password");
                request = {
                  oldPassword: oldPassword,
                  newPassword: newPassword
                };
                _context5.next = 7;
                return this.axios.put(url, request);

              case 7:
                jsonResponse = _context5.sent;
                parsedBodyResponse = jsonResponse.data;
                return _context5.abrupt("return", Result.ok(parsedBodyResponse.message));

              case 12:
                _context5.prev = 12;
                _context5.t0 = _context5["catch"](0);
                return _context5.abrupt("return", ErrorResultHandler(_context5.t0));

              case 15:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 12]]);
      }));

      function changePassword(_x5) {
        return _changePassword.apply(this, arguments);
      }

      return changePassword;
    }()
  }]);

  return UserApi;
}(AxiosApi);